import src from "IMAGE";
export default { src, width: 201, height: 88, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAAAAACWpiEsAAAAKUlEQVR42mP4+fPbxxcvfv5kePn86YMbN5+/Ynjx6Nnjx8+evGD4CQUAEyEdoxrIAYcAAAAASUVORK5CYII="};
